import React, { useState } from "react";
import CustomerSidebar from "../component/CustomerSidebar";
import { Eye, EyeOff } from "react-feather";
import VisitorNavbar from "../component/VisitorNavbar";
import Footer from "../component/Footer";

const CustomerChangePassword = () => {
  const [showPassword, setShowPassword] = useState(false);
  const [showConfirmPassword, setShowConfirmPassword] = useState(false);

  const togglePasswordVisibility = () => {
    setShowPassword((prevState) => !prevState);
  };

  const toggleConfirmPasswordVisibility = () => {
    setShowConfirmPassword((prevState) => !prevState);
  };

  return (
    <>

    <VisitorNavbar/>
    <div>
      <section className="mb-5">
        <div className="container-fluid">
          <div className="row my-3 g-2 justify-content-start">
            <div className="col-md-2">
              <CustomerSidebar />
            </div>
            <div className="col-md-10">
              <div className="reviewcls">
                <h4 className="review-form-heading text-start">
                  Change Password
                </h4>
                <p className="payttl text-start">Update your Password below.</p>
                <hr />
                <form className="contact-form text-start">
                  <div className="row g-2">
                    {/* Password Field */}
                    <div className="col-md-8">
                      <label htmlFor="password" className="form-label">
                        Password <span className="text-danger">*</span>
                      </label>
                      <div className="input-group">
                        <input
                          type={showPassword ? "text" : "password"}
                          id="password"
                          className="form-control"
                          placeholder="Enter your password"
                          required
                        />
                        <span
                          className="input-group-text"
                          onClick={togglePasswordVisibility}
                          style={{ cursor: "pointer" }}
                        >
                          {showPassword ? <EyeOff /> : <Eye />}
                        </span>
                      </div>
                    </div>

                    {/* Confirm Password Field */}
                    <div className="col-md-8">
                      <label htmlFor="confirm-password" className="form-label">
                        Confirm Password <span className="text-danger">*</span>
                      </label>
                      <div className="input-group">
                        <input
                          type={showConfirmPassword ? "text" : "password"}
                          id="confirm-password"
                          className="form-control"
                          placeholder="Enter your confirm password"
                          required
                        />
                        <span
                          className="input-group-text"
                          onClick={toggleConfirmPasswordVisibility}
                          style={{ cursor: "pointer" }}
                        >
                          {showConfirmPassword ? <EyeOff /> : <Eye />}
                        </span>
                      </div>
                    </div>
                  </div>
                  <div className="mt-3 text-end">
                    <button type="submit" className="btn submitbtnn w-25">
                      Update Information
                    </button>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>

<Footer/>
    
    </>
  );
};

export default CustomerChangePassword;
